module.exports = __webpack_public_path__ + "static/chart-customisation-4528a2c6ddd52239837dad6682f736d8.png";